import { ConflictsError, Result } from "aderant-conflicts-models";
import { HttpRequestOptions } from "./sendRequest";

export { sendRequest } from "./sendRequest";
export type AzureFunctionProxy<In, Out, Err extends ConflictsError, QueryParams = never> = (input: In, options?: HttpRequestOptions, queryParams?: QueryParams) => Promise<Result<Out, Err>>;
